__turbopack_context__.v({
  "className": "thesansc5s_4c400402-module__U9PkxG__className",
  "variable": "thesansc5s_4c400402-module__U9PkxG__variable",
});
